import { useEffect, useState, useCallback } from 'react';
import { fetchGamesBalance, GamesBalance } from '../lib/games-api';

export function useGameBalance() {
  const [balance, setBalance] = useState<GamesBalance | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    const data = await fetchGamesBalance();
    setBalance(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { balance, loading, refetch };
}
